<template>
    <div>
        <p class="text-color-gray mb10">输入或粘贴项目名称，每行一个</p>
        <div class="batch-content">
            <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="batchCon"
                :rows="10"
                resize="none"
                style="min-height: 200px;"
                :autofocus="true"
            >
            </el-input>
        </div>
        <p class="tac mt20">
            <el-button type="default" @click="hideBatchModal" class="mr20">取消</el-button>
            <el-button type="primary" @click="submitBatchModal" :loading="batchLoading" class="ml20">提交
            </el-button>
        </p>
    </div>
</template>

<script>
    import API from '@/api/workOrder/create.js';
    export default {
        name: "BatchProjectModal",
        props:['props', 'cbs'],
        data(){
            return {
                batchCon:'',
                batchLoading:false,
            }
        },
        methods:{
            hideBatchModal(){
                this.batchLoading = false;
                this.batchCon = '';
                this.$emit('close');
            },
            submitBatchModal(){
                let batchSearch = this.batchCon.split(/\n/).map(item=>item.trim()).filter(item=>!!item);
                if(batchSearch.length<=0){
                    return this.hideBatchModal();
                }
                this.batchLoading = true;

                API.getProjectOptions({
                    search:'',
                    batch_search:batchSearch,
                }).then(res=>{
                    let resData = (res.data||{}).list||[];
                    let errData = (res.data||{}).err_list||[];
                    this.batchLoading = false;

                    if (errData.length>0) {
                        this.$confirm(`未找到以下项目，请检查输入的内容是否准确，是否需要剔除未找到的项目？<p>${errData.join('、')}</p>`, '提示', {
                            confirmButtonText: '剔除',
                            cancelButtonText: '关闭',
                            dangerouslyUseHTMLString: true,
                            type: 'error'
                        }).then(() => {
                            this.cbs.onSubmit(resData);
                            this.$emit('close');
                        }).catch(() => {})
                    }else {
                        this.cbs.onSubmit(resData);
                        this.$emit('close');
                    }
                },err=>{
                    console.log('getProjectOptions err',err);
                    this.batchLoading = false;
                    if (err?.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                })
                // this.cbs.onSubmit(batchSearch);
                // this.$emit('close');
            },
            hideBatchLoading(){
                this.batchLoading = false;
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>
